(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'AdvancedCruise',
	};

	var afc_search_request = null,
	    selected_ships     = [];

	var _showLoader,
	    _runAfcSearch,
	    _afcCruiseLineChange,
	    _setAfcCruiseShips,
	    _updateAfcDepartureCities,
	    _setAfcDepartures,
	    _updateAfcArrivalCities,
	    _setAfcArrivals,
	    _updateAfcDestinations,
	    _setAfcDestinations,
	    _updateAfcPorts,
	    _setAfcPorts;

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		// All general form element onChange
		$('.afc_form').change(function afcFormChange() {
			var changeVal = $(this).val();

			if (changeVal !== 'xx' && changeVal !== 'zz') {
				_showLoader();
				_runAfcSearch();
			}
		});

		// From date onChange
		$('.afc_from_date').on('dp.change', function afcFromDateChange(e) {
			var startDate = e.date,
			    endDate   = $('.afc_to_date').data('DateTimePicker');

			// if the start date is greater than the end date, add 30 days to the end
			if (endDate.date()) {
				if (endDate.date().isBefore(startDate) === true) {
					endDate.date(startDate.add(30, 'days'));
				}
			}

			_showLoader();
			_updateAfcDepartureCities($('.afc_us_only'));
			_updateAfcArrivalCities($('.afc_us_only_arrivals'));
		});

		// To date onChange
		$('.afc_to_date').on('dp.change', function afcToDateChange(e) {
			var startDate = $('.afc_from_date').data('DateTimePicker'),
			    endDate   = e.date;

			// if the end date is less than the start date, set them to be the same as the end date
			if (endDate) {
				if (endDate.isBefore(startDate.date()) === true) {
					startDate.date(endDate);
				}
			}

			_showLoader();
			_updateAfcDepartureCities($('.afc_us_only'));
			_updateAfcArrivalCities($('.afc_us_only_arrivals'));
		});

		// Cruise line onChange
		$('.afc_cruise_lines').change(function afcCruiseLinesChange() {
			_showLoader();
			_afcCruiseLineChange();
		});

		// Ships onChange
		$('.afc_ships').change(function afcShipsChanged() {
			_showLoader();
			_updateAfcDepartureCities($('.afc_us_only'));
			_updateAfcArrivalCities($('.afc_us_only_arrivals'));
		});

		// Pricing checkbox onChange
		$('.afc_price_checkbox').change(function afcCheckboxChange(e) {
			if ($('.afc_price_checkbox:checked').length === 0) {
				$(this).prop('checked', true);

				Adzuki.StatusMessage('Error', 'You must select at least one Cabin Type.');
			}
		});

		// US arrival ports only onChange
		$('.afc_us_only_arrivals').change(function afcUsArrivalChange() {
			_showLoader();
			_updateAfcArrivalCities($(this));
		});

		// Arrival port onChange
		$('.afc_arrs').change(function afcArrivals() {
			if ($(this).val() !== 'xx') {
				_showLoader();
				_updateAfcDestinations();
			}
		});

		// US departure ports only onChange
		$('.afc_us_only').change(function afcUsDepartureChange() {
			_showLoader();
			_updateAfcDepartureCities($(this));
			_updateAfcArrivalCities($('.afc_us_only_arrivals'));
		});

		// Departure port onChange
		$('.afc_deps').change(function afcDepartures() {
			if ($(this).val() !== 'xx') {
				_showLoader();
				_updateAfcDestinations();
			}
		});

		// Destinations onChange
		$('.afc_destinations').change(function afcDestinations() {
			$(this).data('preselect', $(this).val());

			if ($(this).val() !== 'xx') {
				_showLoader();
				_updateAfcPorts();
			}
		});

		// Ports onChange
		$('.afc_ports').change(function afcPorts() {
			$(this).data('preselect', $(this).val());
		});

		_showLoader(false);
		_afcCruiseLineChange();

		$('.one_way_cruises_only').change(function changed(e) {
			if ($(this).is(':checked')) {
				$('.disembarkation_section').addClass('hidden');
				$('.afc_arrivals').each(function afcClearArrivals() {
					$(this).val(0).trigger('change');
				});
				$('#advancedcruise-only_us_arrival_ports').prop('checked', false).trigger('change');
			} else {
				$('.afc_arrivals').each(function afcClearArrivals() {
					$(this).val(0).trigger('change');
				});
				$('#advancedcruise-only_us_arrival_ports').prop('checked', false).trigger('change');
				$('.disembarkation_section').removeClass('hidden');
			}
		});
	};

	_showLoader = function _showLoader(show_clear_criteria)
	{
		$('#cruiseCriteria').html('<i class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-spin fa-2x"></i>&nbsp;<span class="afc">Finding sailings...</span>');
		$('.bottom-panel-result-count').html('<i class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-spin small-spin"></i>&nbsp;<span class="afc">Searching...</span>');

		if (show_clear_criteria === undefined || show_clear_criteria) {
			$('.afc-clear-criteria').removeClass('hidden');
		}
	};

	_runAfcSearch = function _runAfcSearch()
	{
		if (afc_search_request !== null) {
			afc_search_request.abort();
			afc_search_request = null;
		}

		afc_search_request = Adzuki.Ajax.post('/CruiseSearch/getFacSearchCount', $('#AdvancedCruise').serialize());

		afc_search_request.then(
			function success(response) {
				$('.bottom-panel').addClass('show');
				$('#cruiseCriteria').html(response);
				$('.bottom-panel-result-count').html($('#itinerary_count').val());

				$('.afc_save_criteria').click(function afcSaveWatchList() {
					if ($(this).prop('checked') === true) {
						$('.afc-watchlist-box').show();
						$('.afc-submit').html('Save & View Sailings');
					} else {
						$('.afc-watchlist-box').hide();
						$('input[type=checkbox]').val('0'); // This will change the value of input checkbox from 1 to 0, so when box is hidden validationData wont run on it.
						$('.afc-submit').html('View Sailings');
					}
				});

				if ($('.afc-watchlist-box').is(':visible')) {
					$('.afc_save_criteria').prop('checked', true);
				}
				afc_search_request = null;
			}
		);
	};

	_afcCruiseLineChange = function _afcCruiseLineChange()
	{
		var cruise_line_ids = '';
		var include_exclude = '';
		var cruise_line_val = '';
		var ships_val       = '';
		var exclude_ids     = '';
		var i               = 0;

		for (i=0; i<=3; i++) {
			include_exclude = $('#advancedcruise-include_exclude_cruise_lines-' + i).val();
			cruise_line_val = $('#advancedcruise-cruise_lines-' + i).val();
			ships_val       = $('#advancedcruise-ships-' + i).val();

			if (cruise_line_val !== '0' && cruise_line_val !== undefined && include_exclude !== 'exclude') {
				cruise_line_ids += cruise_line_val + ',';
			}

			if (cruise_line_val !== '0' && cruise_line_val !== undefined && include_exclude === 'exclude') {
				exclude_ids += cruise_line_val + ',';
			}

			if (ships_val !== '0' && ships_val !== undefined) {
				selected_ships[i] = ships_val;
			}
		}

		if (cruise_line_ids === '') {
			cruise_line_ids = '0';
		}

		if (exclude_ids === '') {
			exclude_ids = '0';
		}

		Adzuki.Ajax.get('/CruiseSearch/getFacShips/' + cruise_line_ids + '/' + exclude_ids)
		.then(function success(data) {
			var optgroup;
			var sortedData;

			$('.afc_ships').empty();

			$('.afc_ships').append($('<option>').text('Choose Cruise Ship').attr('value', 0));

			$.each(data, function facParseShips(key, value) {
				optgroup = $('<optgroup>');

				if (key !== '0') {
					optgroup.attr('label', key);

					sortedData = Adzuki.Sort.alphabeticValue(value);

					$.each(sortedData, function facParseShipsByCruiseLine(sKey, sValue) {
						optgroup.append($('<option>').text(sValue.value).attr('value', sValue.key));
					});

					$('.afc_ships').append(optgroup);
				}
			});

			_setAfcCruiseShips();
			_updateAfcDepartureCities($('.afc_us_only'));
			_updateAfcArrivalCities($('.afc_us_only_arrivals'));
		});
	};

	_setAfcCruiseShips = function _setAfcCruiseShips()
	{
		var i            = 0,
		    orig_ship_id;

		// $('.afc_ships').val(0);

		if (selected_ships.length > 0) {
			for (i=0; i<=3; i++) {
				if (selected_ships[i] !== undefined) {
					orig_ship_id = $("#advancedcruise-ships-" + i).val();

					$("#advancedcruise-ships-" + i).val(selected_ships[i]);

					if ($("#advancedcruise-ships-" + i).val() === null) {
						$("#advancedcruise-ships-" + i).val(orig_ship_id);
					}
				}
			}
		}
	};

	_updateAfcArrivalCities = function _updateAfcArrivalCities(obj)
	{
		var us_only = 0;

		if ($(obj).prop('checked') === true) {
			us_only = 1;
		}

		Adzuki.Ajax.post('/CruiseSearch/getFacArrivalPorts/' + us_only, $('#AdvancedCruise').serialize()).then(function success(data) {
			var sortedData;
			var optgroup;

			if (us_only === 0) {
				$('.afc_arrivals').each(function afcClearArrivals() {
					$(this).empty();
					$(this).append($('<option>').text('Choose Disembarkation Port').attr('value', '0'));
				});

				sortedData = Adzuki.Sort.alphabeticValue(data);

				$.each(sortedData, function facParsePorts(sKey, sValue) {
					$('.afc_arrivals').append($('<option>').text(sValue.value).attr('value', sValue.key));
				});
			} else {
				$('.afc_arrivals').empty();
				$('.afc_arrivals').append($('<option>').text('Choose Disembarkation Port').attr('value', 0));

				$.each(data, function facParsePorts(states, cities) {
					optgroup = $('<optgroup>');

					if (states !== '0' && states !== 'xx') {
						optgroup.attr('label', states);

						$.each(cities, function facParsePortsForUs(key, value) {
							optgroup.append($('<option>').text(value.value).attr('value', value.key));
						});

						$('.afc_arrivals').append(optgroup);
					}
				});
			}

			_setAfcArrivals();
			_updateAfcDestinations();
		});
	};

	_setAfcArrivals = function _setAfcArrivals()
	{
		$('.afc_arrivals').each(function selectValueForArrival() {
			if ($(this).data('preselect')) {
				$(this).val($(this).data('preselect'));
			}
		});
	};

	_updateAfcDepartureCities = function _updateAfcDepartureCities(obj)
	{
		var us_only = 0;

		if ($(obj).prop('checked') === true) {
			us_only = 1;
		}

		Adzuki.Ajax.post('/CruiseSearch/getFacPorts/' + us_only, $('#AdvancedCruise').serialize()).then(function success(data) {
			var sortedData;
			var optgroup;

			if (us_only === 0) {
				$('.afc_departures').each(function afcClearDepartures() {
					$(this).empty();
					$(this).append($('<option>').text('Choose Embarkation Port').attr('value', '0'));
				});

				sortedData = Adzuki.Sort.alphabeticValue(data);

				$.each(sortedData, function facParsePorts(sKey, sValue) {
					$('.afc_departures').append($('<option>').text(sValue.value).attr('value', sValue.key));
				});
			} else {
				$('.afc_departures').empty();
				$('.afc_departures').append($('<option>').text('Choose Embarkation Port').attr('value', 0));

				$.each(data, function facParsePorts(states, cities) {
					optgroup = $('<optgroup>');

					if (states !== '0' && states !== 'xx') {
						optgroup.attr('label', states);

						$.each(cities, function facParsePortsForUs(key, value) {
							optgroup.append($('<option>').text(value.value).attr('value', value.key));
						});

						$('.afc_departures').append(optgroup);
					}
				});
			}

			_setAfcDepartures();
			_updateAfcDestinations();
		});
	};

	_setAfcDepartures = function _setAfcDepartures()
	{
		$('.afc_departures').each(function selectValueForDeparture() {
			if ($(this).data('preselect')) {
				$(this).val($(this).data('preselect'));
			}
		});
	};

	_updateAfcDestinations = function _updateAfcDestinations(obj)
	{
		Adzuki.Ajax.post('/CruiseSearch/getFacDestinations/', $('#AdvancedCruise').serialize()).then(function success(data) {
			$('.afc_destinations').each(function afcClearDestinations() {
				$(this).empty();
			});

			$.each(data, function facParseDestinations(sKey, sValue) {
				$('.afc_destinations').append($('<option>').text(sValue).attr('value', sKey));
			});

			_setAfcDestinations();
			_updateAfcPorts();
		});
	};

	_setAfcDestinations = function _setAfcDestinations()
	{
		$('.afc_destinations').each(function selectValueForDestination() {
			if ($(this).data('preselect')) {
				$(this).val($(this).data('preselect'));
			}
		});
	};

	_updateAfcPorts = function _updateAfcPorts(obj)
	{
		Adzuki.Ajax.post('/CruiseSearch/getFacPortsOfCall/', $('#AdvancedCruise').serialize()).then(function success(data) {
			var optgroup;

			$('.afc_ports').empty();

			$('.afc_ports').append($('<option>').text('Choose Port of Call').attr('value', 0));

			$.each(data, function facParsePortsByCountries(countries, cities) {
				optgroup = $('<optgroup>');

				if (countries !== '0' && countries !== 'xx') {
					optgroup.attr('label', countries);

					$.each(cities, function facParsePortsByCountry(key, value) {
						optgroup.append($('<option>').text(value.value).attr('value', value.key));
					});

					$('.afc_ports').append(optgroup);
				}
			});

			_setAfcPorts();
			_runAfcSearch(false);
		});
	};

	_setAfcPorts = function _setAfcPorts()
	{
		$('.afc_ports').each(function selectValueForDestination() {
			if ($(this).data('preselect')) {
				$(this).val($(this).data('preselect'));
			}
		});
	};
}(jQuery, window.Adzuki || {}));
